"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _dateRange = _interopRequireDefault(require("@gravity/date-range"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _product = require("@nucleo/product");
var _ProductDescriptionIcon = _interopRequireDefault(require("./ProductDescriptionIcon"));
var _jsxFileName = "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductDate.js",
  _templateObject,
  _templateObject2,
  _templateObject3;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_yx633zosh() {
  var path = "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductDate.js";
  var hash = "6470a84e5a571b4ad6a38f1ce32e758da9388979";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductDate.js",
    statementMap: {
      "0": {
        start: {
          line: 25,
          column: 18
        },
        end: {
          line: 34,
          column: 1
        }
      },
      "1": {
        start: {
          line: 36,
          column: 24
        },
        end: {
          line: 92,
          column: 2
        }
      },
      "2": {
        start: {
          line: 93,
          column: 16
        },
        end: {
          line: 98,
          column: 1
        }
      },
      "3": {
        start: {
          line: 94,
          column: 22
        },
        end: {
          line: 94,
          column: 74
        }
      },
      "4": {
        start: {
          line: 115,
          column: 18
        },
        end: {
          line: 115,
          column: 22
        }
      },
      "5": {
        start: {
          line: 116,
          column: 17
        },
        end: {
          line: 116,
          column: 21
        }
      },
      "6": {
        start: {
          line: 117,
          column: 2
        },
        end: {
          line: 127,
          column: 3
        }
      },
      "7": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 34
        }
      },
      "8": {
        start: {
          line: 119,
          column: 9
        },
        end: {
          line: 127,
          column: 3
        }
      },
      "9": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 31
        }
      },
      "10": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 28
        }
      },
      "11": {
        start: {
          line: 122,
          column: 9
        },
        end: {
          line: 127,
          column: 3
        }
      },
      "12": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 123,
          column: 40
        }
      },
      "13": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 95
        }
      },
      "14": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 93
        }
      },
      "15": {
        start: {
          line: 129,
          column: 32
        },
        end: {
          line: 129,
          column: 91
        }
      },
      "16": {
        start: {
          line: 132,
          column: 2
        },
        end: {
          line: 134,
          column: 3
        }
      },
      "17": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 16
        }
      },
      "18": {
        start: {
          line: 135,
          column: 13
        },
        end: {
          line: 135,
          column: 17
        }
      },
      "19": {
        start: {
          line: 136,
          column: 2
        },
        end: {
          line: 160,
          column: 3
        }
      },
      "20": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 148,
          column: 6
        }
      },
      "21": {
        start: {
          line: 150,
          column: 9
        },
        end: {
          line: 160,
          column: 3
        }
      },
      "22": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 151,
          column: 56
        }
      },
      "23": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 159,
          column: 6
        }
      },
      "24": {
        start: {
          line: 162,
          column: 2
        },
        end: {
          line: 164,
          column: 3
        }
      },
      "25": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 163,
          column: 90
        }
      },
      "26": {
        start: {
          line: 165,
          column: 16
        },
        end: {
          line: 165,
          column: 35
        }
      },
      "27": {
        start: {
          line: 166,
          column: 16
        },
        end: {
          line: 166,
          column: 34
        }
      },
      "28": {
        start: {
          line: 167,
          column: 19
        },
        end: {
          line: 167,
          column: 27
        }
      },
      "29": {
        start: {
          line: 168,
          column: 19
        },
        end: {
          line: 168,
          column: 59
        }
      },
      "30": {
        start: {
          line: 170,
          column: 2
        },
        end: {
          line: 213,
          column: 4
        }
      },
      "31": {
        start: {
          line: 216,
          column: 0
        },
        end: {
          line: 238,
          column: 2
        }
      },
      "32": {
        start: {
          line: 240,
          column: 0
        },
        end: {
          line: 251,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 94,
            column: 13
          },
          end: {
            line: 94,
            column: 14
          }
        },
        loc: {
          start: {
            line: 94,
            column: 22
          },
          end: {
            line: 94,
            column: 74
          }
        },
        line: 94
      },
      "1": {
        name: "ProductDate",
        decl: {
          start: {
            line: 102,
            column: 9
          },
          end: {
            line: 102,
            column: 20
          }
        },
        loc: {
          start: {
            line: 114,
            column: 3
          },
          end: {
            line: 214,
            column: 1
          }
        },
        line: 114
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 117,
            column: 2
          },
          end: {
            line: 127,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 117,
            column: 2
          },
          end: {
            line: 127,
            column: 3
          }
        }, {
          start: {
            line: 119,
            column: 9
          },
          end: {
            line: 127,
            column: 3
          }
        }],
        line: 117
      },
      "1": {
        loc: {
          start: {
            line: 119,
            column: 9
          },
          end: {
            line: 127,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 9
          },
          end: {
            line: 127,
            column: 3
          }
        }, {
          start: {
            line: 122,
            column: 9
          },
          end: {
            line: 127,
            column: 3
          }
        }],
        line: 119
      },
      "2": {
        loc: {
          start: {
            line: 122,
            column: 9
          },
          end: {
            line: 127,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 9
          },
          end: {
            line: 127,
            column: 3
          }
        }, {
          start: {
            line: 124,
            column: 9
          },
          end: {
            line: 127,
            column: 3
          }
        }],
        line: 122
      },
      "3": {
        loc: {
          start: {
            line: 125,
            column: 16
          },
          end: {
            line: 125,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 125,
            column: 17
          },
          end: {
            line: 125,
            column: 41
          }
        }, {
          start: {
            line: 125,
            column: 45
          },
          end: {
            line: 125,
            column: 72
          }
        }, {
          start: {
            line: 125,
            column: 77
          },
          end: {
            line: 125,
            column: 94
          }
        }],
        line: 125
      },
      "4": {
        loc: {
          start: {
            line: 126,
            column: 15
          },
          end: {
            line: 126,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 16
          },
          end: {
            line: 126,
            column: 40
          }
        }, {
          start: {
            line: 126,
            column: 44
          },
          end: {
            line: 126,
            column: 71
          }
        }, {
          start: {
            line: 126,
            column: 76
          },
          end: {
            line: 126,
            column: 92
          }
        }],
        line: 126
      },
      "5": {
        loc: {
          start: {
            line: 129,
            column: 32
          },
          end: {
            line: 129,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 129,
            column: 32
          },
          end: {
            line: 129,
            column: 40
          }
        }, {
          start: {
            line: 129,
            column: 45
          },
          end: {
            line: 129,
            column: 53
          }
        }, {
          start: {
            line: 129,
            column: 57
          },
          end: {
            line: 129,
            column: 68
          }
        }, {
          start: {
            line: 129,
            column: 72
          },
          end: {
            line: 129,
            column: 90
          }
        }],
        line: 129
      },
      "6": {
        loc: {
          start: {
            line: 132,
            column: 2
          },
          end: {
            line: 134,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 2
          },
          end: {
            line: 134,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 132
      },
      "7": {
        loc: {
          start: {
            line: 136,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 136,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        }, {
          start: {
            line: 150,
            column: 9
          },
          end: {
            line: 160,
            column: 3
          }
        }],
        line: 136
      },
      "8": {
        loc: {
          start: {
            line: 150,
            column: 9
          },
          end: {
            line: 160,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 150,
            column: 9
          },
          end: {
            line: 160,
            column: 3
          }
        }, {
          start: {
            line: 152,
            column: 9
          },
          end: {
            line: 160,
            column: 3
          }
        }],
        line: 150
      },
      "9": {
        loc: {
          start: {
            line: 162,
            column: 2
          },
          end: {
            line: 164,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 162,
            column: 2
          },
          end: {
            line: 164,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 162
      },
      "10": {
        loc: {
          start: {
            line: 168,
            column: 31
          },
          end: {
            line: 168,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 168,
            column: 31
          },
          end: {
            line: 168,
            column: 52
          }
        }, {
          start: {
            line: 168,
            column: 56
          },
          end: {
            line: 168,
            column: 58
          }
        }],
        line: 168
      },
      "11": {
        loc: {
          start: {
            line: 172,
            column: 7
          },
          end: {
            line: 201,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 172,
            column: 7
          },
          end: {
            line: 172,
            column: 28
          }
        }, {
          start: {
            line: 173,
            column: 8
          },
          end: {
            line: 173,
            column: 17
          }
        }, {
          start: {
            line: 174,
            column: 10
          },
          end: {
            line: 200,
            column: 28
          }
        }],
        line: 172
      },
      "12": {
        loc: {
          start: {
            line: 179,
            column: 13
          },
          end: {
            line: 179,
            column: 151
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 179,
            column: 14
          },
          end: {
            line: 179,
            column: 22
          }
        }, {
          start: {
            line: 179,
            column: 26
          },
          end: {
            line: 179,
            column: 74
          }
        }, {
          start: {
            line: 179,
            column: 79
          },
          end: {
            line: 179,
            column: 151
          }
        }],
        line: 179
      },
      "13": {
        loc: {
          start: {
            line: 183,
            column: 15
          },
          end: {
            line: 189,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 183,
            column: 15
          },
          end: {
            line: 183,
            column: 34
          }
        }, {
          start: {
            line: 184,
            column: 16
          },
          end: {
            line: 184,
            column: 26
          }
        }, {
          start: {
            line: 185,
            column: 16
          },
          end: {
            line: 185,
            column: 24
          }
        }, {
          start: {
            line: 185,
            column: 28
          },
          end: {
            line: 189,
            column: 17
          }
        }],
        line: 183
      },
      "14": {
        loc: {
          start: {
            line: 191,
            column: 15
          },
          end: {
            line: 198,
            column: 22
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 192,
            column: 16
          },
          end: {
            line: 197,
            column: 27
          }
        }, {
          start: {
            line: 198,
            column: 18
          },
          end: {
            line: 198,
            column: 22
          }
        }],
        line: 191
      },
      "15": {
        loc: {
          start: {
            line: 191,
            column: 15
          },
          end: {
            line: 191,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 191,
            column: 15
          },
          end: {
            line: 191,
            column: 34
          }
        }, {
          start: {
            line: 191,
            column: 38
          },
          end: {
            line: 191,
            column: 83
          }
        }],
        line: 191
      },
      "16": {
        loc: {
          start: {
            line: 202,
            column: 7
          },
          end: {
            line: 211,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 202,
            column: 7
          },
          end: {
            line: 202,
            column: 15
          }
        }, {
          start: {
            line: 203,
            column: 8
          },
          end: {
            line: 210,
            column: 26
          }
        }],
        line: 202
      },
      "17": {
        loc: {
          start: {
            line: 208,
            column: 11
          },
          end: {
            line: 208,
            column: 153
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 208,
            column: 12
          },
          end: {
            line: 208,
            column: 20
          }
        }, {
          start: {
            line: 208,
            column: 24
          },
          end: {
            line: 208,
            column: 72
          }
        }, {
          start: {
            line: 208,
            column: 77
          },
          end: {
            line: 208,
            column: 153
          }
        }],
        line: 208
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0],
      "4": [0, 0, 0],
      "5": [0, 0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0, 0],
      "13": [0, 0, 0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6470a84e5a571b4ad6a38f1ce32e758da9388979"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_yx633zosh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_yx633zosh();
var ICONS_MAP = (cov_yx633zosh().s[0]++, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, {
  calendar: 'calendar',
  time: 'time'
}), _themeProvider.TicketShopTheme.EVOLUTION, {
  calendar: 'riCalendarEventLine',
  time: 'riTimeLine'
}));
var DateTimeWrapper = (cov_yx633zosh().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.div, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    position: relative;\n    display: flex;\n    margin: 0;\n    font-size: ", ";\n    > div > span {\n      vertical-align: sub;\n    }\n    @media screen and (max-width: 40em) {\n      justify-content: center;\n    }\n\n    .stx-product {\n      width: 100%;\n    }\n    p.semantic-no-styling {\n      margin: 0;\n    }\n  "])), _stylingConstants.default.font.sizeS)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    position: relative;\n    display: flex;\n    margin: 0;\n    align-items: center;\n    > div > span {\n      vertical-align: sub;\n    }\n\n    .stx-product {\n      width: 100%;\n    }\n    p.semantic-no-styling {\n      margin: 0;\n    }\n\n    --date-color: var(--subtleTextColor, #7f8c8d);\n    --date-line-height: ", ";\n    --date-font-size: ", ";\n    > .g-Icon {\n      color: var(--subtleTextColor, #7f8c8d);\n      font-size: ", ";\n      line-height: var(--date-line-height);\n      margin-bottom: 0;\n      margin-right: 8px;\n      width: 16px;\n      height: 18px;\n    }\n\n    p.semantic-no-styling {\n      color: var(--date-color);\n      font-size: var(--date-font-size);\n      line-height: var(--date-line-height);\n      font-weight: ", ";\n    }\n  "])), _themeMapper.evolutionTheme.typography.caption1.lineHeight, _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.typography.body2.fontSize, _themeMapper.evolutionTheme.fontWeight.normal))));
var Wrapper = (cov_yx633zosh().s[2]++, _styledComponents.default.div.attrs({
  className: function className(props) {
    cov_yx633zosh().f[0]++;
    cov_yx633zosh().s[3]++;
    return "stx-ProductDate stx-ProductDate-".concat(props.productId);
  },
  'aria-live': 'polite'
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: ", ";\n"])), _stylingConstants.default.spacing.xsmall));
/*
 * Component to display the date of a product. Using from ... to ... if first date and last date, or the date if only first date
 */
function ProductDate(_ref2) {
  var product = _ref2.product,
    performance = _ref2.performance,
    timeslot = _ref2.timeslot,
    hospitalitySession = _ref2.hospitalitySession,
    showDate = _ref2.showDate,
    showTime = _ref2.showTime,
    showTimeTo = _ref2.showTimeTo,
    showIcon = _ref2.showIcon,
    showVenue = _ref2.showVenue,
    isOneClickPurchase = _ref2.isOneClickPurchase,
    themeContext = _ref2.themeContext;
  cov_yx633zosh().f[1]++;
  var firstDate = (cov_yx633zosh().s[4]++, null);
  var lastDate = (cov_yx633zosh().s[5]++, null);
  cov_yx633zosh().s[6]++;
  if (performance) {
    cov_yx633zosh().b[0][0]++;
    cov_yx633zosh().s[7]++;
    firstDate = performance.start;
  } else {
    cov_yx633zosh().b[0][1]++;
    cov_yx633zosh().s[8]++;
    if (timeslot) {
      cov_yx633zosh().b[1][0]++;
      cov_yx633zosh().s[9]++;
      firstDate = timeslot.start;
      cov_yx633zosh().s[10]++;
      lastDate = timeslot.end;
    } else {
      cov_yx633zosh().b[1][1]++;
      cov_yx633zosh().s[11]++;
      if (hospitalitySession) {
        cov_yx633zosh().b[2][0]++;
        cov_yx633zosh().s[12]++;
        firstDate = hospitalitySession.date;
      } else {
        cov_yx633zosh().b[2][1]++;
        cov_yx633zosh().s[13]++;
        firstDate = (cov_yx633zosh().b[3][0]++, product.productDateRange) && (cov_yx633zosh().b[3][1]++, product.productDateRange[0]) || (cov_yx633zosh().b[3][2]++, product.firstDate);
        cov_yx633zosh().s[14]++;
        lastDate = (cov_yx633zosh().b[4][0]++, product.productDateRange) && (cov_yx633zosh().b[4][1]++, product.productDateRange[1]) || (cov_yx633zosh().b[4][2]++, product.lastDate);
      }
    }
  }
  // if the occurrence is not passed, do not show the time for a product
  var showTimeForOccurrence = (cov_yx633zosh().s[15]++, (cov_yx633zosh().b[5][0]++, showTime) && ((cov_yx633zosh().b[5][1]++, timeslot) || (cov_yx633zosh().b[5][2]++, performance) || (cov_yx633zosh().b[5][3]++, hospitalitySession)));

  // if there is no date, do not display anything for dates
  cov_yx633zosh().s[16]++;
  if (!firstDate) {
    cov_yx633zosh().b[6][0]++;
    cov_yx633zosh().s[17]++;
    return null;
  } else {
    cov_yx633zosh().b[6][1]++;
  }
  var date = (cov_yx633zosh().s[18]++, null);
  cov_yx633zosh().s[19]++;
  if (showTimeForOccurrence) {
    cov_yx633zosh().b[7][0]++;
    cov_yx633zosh().s[20]++;
    // If we want the time, show it inline with the date
    date = /*#__PURE__*/_react.default.createElement("p", {
      className: "semantic-no-styling",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 139,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedTime, {
      value: firstDate,
      day: "numeric",
      month: "short",
      year: "numeric",
      timeZone: "UTC",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 140,
        columnNumber: 9
      }
    }));
    // if there is a last date use the range
  } else {
    cov_yx633zosh().b[7][1]++;
    cov_yx633zosh().s[21]++;
    if (lastDate) {
      cov_yx633zosh().b[8][0]++;
      cov_yx633zosh().s[22]++;
      date = /*#__PURE__*/_react.default.createElement(_dateRange.default, {
        from: firstDate,
        to: lastDate,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 151,
          columnNumber: 12
        }
      });
    } else {
      cov_yx633zosh().b[8][1]++;
      cov_yx633zosh().s[23]++;
      // if we only want the date, show it

      date = /*#__PURE__*/_react.default.createElement("p", {
        className: "semantic-no-styling",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 156,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
        value: firstDate,
        day: "numeric",
        month: "short",
        timeZone: "UTC",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 157,
          columnNumber: 9
        }
      }));
    }
  }
  cov_yx633zosh().s[24]++;
  if (isOneClickPurchase) {
    cov_yx633zosh().b[9][0]++;
    cov_yx633zosh().s[25]++;
    date = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
      value: firstDate,
      month: "short",
      day: "2-digit",
      timeZone: "UTC",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 163,
        columnNumber: 12
      }
    });
  } else {
    cov_yx633zosh().b[9][1]++;
  }
  var fDate = (cov_yx633zosh().s[26]++, new Date(firstDate));
  var lDate = (cov_yx633zosh().s[27]++, new Date(lastDate));
  var timeADay = (cov_yx633zosh().s[28]++, 86400000);
  var keyLangs = (cov_yx633zosh().s[29]++, (0, _keys.default)((cov_yx633zosh().b[10][0]++, performance === null || performance === void 0 ? void 0 : performance.rawVenue) || (cov_yx633zosh().b[10][1]++, {})));
  cov_yx633zosh().s[30]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    productId: product.id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 171,
      columnNumber: 5
    }
  }, (cov_yx633zosh().b[11][0]++, showTimeForOccurrence) && (cov_yx633zosh().b[11][1]++, !showDate) && (cov_yx633zosh().b[11][2]++, /*#__PURE__*/_react.default.createElement(DateTimeWrapper, {
    productId: product.id // we want to show the time and we have an occurrence // and it is not yet shown in the date
    ,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 174,
      columnNumber: 11
    }
  }, ' ', ((cov_yx633zosh().b[12][0]++, showIcon) || (cov_yx633zosh().b[12][1]++, themeContext.theme === _themeProvider.TicketShopTheme.EVOLUTION)) && (cov_yx633zosh().b[12][2]++, /*#__PURE__*/_react.default.createElement(_ProductDescriptionIcon.default, {
    iconName: ICONS_MAP[themeContext.theme].time,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 80
    }
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "stx-product",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 180,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedTime, {
    value: firstDate,
    hour12: false,
    timeZone: "UTC",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 181,
      columnNumber: 15
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 182,
      columnNumber: 15
    }
  }, "\xA0"), (cov_yx633zosh().b[13][0]++, !isOneClickPurchase) && (cov_yx633zosh().b[13][1]++, showTimeTo) && (cov_yx633zosh().b[13][2]++, lastDate) && (cov_yx633zosh().b[13][3]++, ['-', /*#__PURE__*/_react.default.createElement("span", {
    key: "span_".concat(lastDate),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 187,
      columnNumber: 19
    }
  }, "\xA0"), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedTime, {
    key: "formattedTime_".concat(lastDate),
    value: lastDate,
    hour12: false,
    timeZone: "UTC",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 188,
      columnNumber: 19
    }
  })]), (cov_yx633zosh().b[15][0]++, !isOneClickPurchase) && (cov_yx633zosh().b[15][1]++, lDate.getTime() - fDate.getTime() >= timeADay) ? (cov_yx633zosh().b[14][0]++, /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 192,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 193,
      columnNumber: 19
    }
  }, "\xA0"), ' (', /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
    value: lastDate,
    timeZone: "UTC",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 195,
      columnNumber: 19
    }
  }), ')')) : (cov_yx633zosh().b[14][1]++, null)))), (cov_yx633zosh().b[16][0]++, showDate) && (cov_yx633zosh().b[16][1]++, /*#__PURE__*/_react.default.createElement(DateTimeWrapper, {
    productId: product.id // we show the date, the time is included if showtime is true
    ,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 203,
      columnNumber: 9
    }
  }, ' ', ((cov_yx633zosh().b[17][0]++, showIcon) || (cov_yx633zosh().b[17][1]++, themeContext.theme === _themeProvider.TicketShopTheme.EVOLUTION)) && (cov_yx633zosh().b[17][2]++, /*#__PURE__*/_react.default.createElement(_ProductDescriptionIcon.default, {
    iconName: ICONS_MAP[themeContext.theme].calendar,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 208,
      columnNumber: 78
    }
  })), date)));
}
cov_yx633zosh().s[31]++;
ProductDate.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType,
  /* A specific hospitality session to display, if provided take the hospitality session data in priority */
  hospitalitySession: _product.HospitalitySessionType,
  /** Tells if the Date part of the date-time should be shown */
  showDate: _propTypes.default.bool,
  /** Tells if the time part of the date-time should be shown, it only works if a performance or a timeslot is passed */
  showTime: _propTypes.default.bool,
  /** Tells if the time to should be shown, it only works if a performance or a timeslot is passed */
  showTimeTo: _propTypes.default.bool,
  /** Tells if the time icon should be shown or not */
  showIcon: _propTypes.default.bool,
  /** Indicate that we are in a one click purchase widget */
  isOneClickPurchase: _propTypes.default.bool,
  themeContext: _themeProvider.ThemeContextType,
  /** Tells if the venue should be shown */
  showVenue: _propTypes.default.bool
};
cov_yx633zosh().s[32]++;
ProductDate.defaultProps = {
  performance: null,
  timeslot: null,
  hospitalitySession: null,
  showDate: true,
  showTime: true,
  showTimeTo: true,
  showIcon: true,
  showVenue: true,
  isOneClickPurchase: null,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)(ProductDate);